module.exports = __webpack_public_path__ + "static/media/sustenance-logo.06771469.ico";